module.exports = __webpack_public_path__ + "img/check.388f0bba.png";